<style scoped>
.upload_img_box {
    padding-top: 5px;
    width: 300px;
    min-height: 100px;
    line-height: 0;
    background: #fff;
    position: relative;
}
.upload_img_box video {
    /*height: 150px;*/
    width: 300px;
}
.upload_img_box img {
    max-width: 300px;
}
.upload_img_box video {
    height: 150px;
}
.upload-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}
.upload_img_box:hover .upload-cover {
    display: flex;
    align-items: center;
    justify-content: center;
}
.upload-cover i,
.upload-cover span {
    color: #fff;
    font-size: 30px;
    cursor: pointer;
    margin: 0 20px;
    /* position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px; */
}
.file_box {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
}
.file_box .ivu-tooltip {
    font-size: 20px;
    position: absolute;
    right: 5px;
    top: 5px;
}
.file_box img {
    /*max-width: 300px;*/
    max-height: 110px;
}
.upload_video_box {
    padding-top: 10px;
}
.upload_video_box > div {
    padding-bottom: 20px;
}
.audio_box {
    width: 400px;
    height: 50px;
}
.audio_box audio {
    width: 350px;
    margin-right: 10px;
}
.audio_box audio,
.audio_box button {
    vertical-align: middle;
}
.audio_box p {
    line-height: 30px;
    font-size: 15px;
}
.srt_box {
    margin-top: 6px;
    line-height: 20px;
}
.upload_video_box {
    margin-bottom: 20px;
}
.upload_video_input {
    width: 110px;
    height: 40px;
    position: relative;
}
.upload_video_box input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
}
.upload_video_box button {
    position: absolute;
    top: 0;
    left: 0;
}
.spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
.spin-col {
    height: 100px;
    width: 350px;
    position: relative;
    /*border: 1px solid #eee;*/
}
.ivu-spin-text div {
    padding-top: 15px;
}
.delete_video {
    position: absolute;
    right: -50px;
    top: 0;
    z-index: 10;
    color: #fff;
}
.srt_box > div {
    display: inline-block;
    vertical-align: top;
}
.srt_box_title {
    padding-top: 15px;
    width: 15%;
}
.srt_box_info {
    width: 80%;
}
.preview_image_box{
    width:100%;
    height:100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
>>> .ivu-upload-list {
    display: none;
}
</style>
<template>
    <!-- 视频 -->
    <div class="upload_img_box" v-if="fatherType==3">
        <!--<Tooltip class="delete_video" content="删除" placement="right">-->
        <!--<Button type="error" shape="circle" icon="ios-trash-outline" @click="removeFile()" style="margin-left: 5px"></Button>-->
        <!--</Tooltip>-->
        <Button
            type="error"
            @click="removeVideo()"
            size="small"
            class="delete_video"
        >删除视频</Button>
        <!-- <div style="padding-bottom: 10px;">
            是否在app显示视频名称:
            <RadioGroup v-model="isShowName">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
            </RadioGroup>
        </div>
        <div>
            视频展示名称:
            <Input
                style="width: 180px"
                v-model="showName"
                size="small"
                placeholder="视频展示名称"
                onkeypress="if(event.keyCode == 13) return false;"
            />
        </div> -->
        <!-- <p v-if="title" class="srt_box">视频名称: {{title}}</p> -->
        <div class="spin-col" v-if="videoLoading">
            <Spin fix>
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>视频转码中, 请等待</div>
                <div>如果中途退出将取消上传</div>
            </Spin>
        </div>
        <div v-if="mp4PlayUrl">
            <div class="file_box">
                <video
                    controls="controls"
                    controlslist="nodownload"
                    muted
                    :poster="coverUrl"
                    :src="mp4PlayUrl"
                ></video>
            </div>
        </div>
        <div class="upload_box" v-else>
            <div class="upload_video_box" v-if="uploadStatus != 'onUploadEnd'">
                <div v-if="uploadVideoAuth.videoId">
                    <Progress :percent="uploadPercent" />
                </div>
                <div class="upload_video_input" v-else>
                    <input
                        type="file"
                        :accept="fatherType | changeFatherAccept"
                        name
                        @change="changeVideo($event)"
                    />
                    <Button
                        :icon="fatherType | changeFatherIcon"
                        size="large"
                        type="primary"
                        ghost
                    >上传视频</Button>
                </div>
            </div>
        </div>
        <!-- <div v-if="srt" class="srt_box">
            <div class="srt_box_title">字幕:</div>
            <div class="srt_box_info">
                <Icon type="ios-closed-captioning" size="45" />
                <Button
                    type="error"
                    @click="removeSrt()"
                    size="small"
                    style="margin-left: 40px;"
                >删除字幕</Button>
                <br />
                <a :href="srt">{{srt.split('/')[srt.split('/').length-1]}}</a>
            </div>
        </div>
        <div class="upload_box" v-else>
            <Upload
                :before-upload="handleUpload"
                ref="upload"
                type="drag"
                :data="uploadData"
                :action="uploadUrl"
            >
                <div style="padding: 30px 0">
                    <Icon
                        v-if="uploading"
                        type="ios-loading"
                        size="18"
                        class="spin-icon-load"
                        style="color: #3399ff;margin-bottom: 10px"
                    ></Icon>
                    <Icon
                        v-else
                        type="ios-closed-captioning"
                        size="40"
                        style="color: #3399ff;margin-bottom: 10px"
                    ></Icon>
                    <p v-if="uploading">字幕文件上传中, 请稍后</p>
                    <p v-else>将字幕文件拖拽到此，或直接上传</p>
                </div>
            </Upload>
        </div> -->
    </div>
    <!-- 图片/音频等 -->
    <div class="upload_img_box" v-else>
        <div v-if="imageUrl">
            <div class="file_box">
                <img :src="imageUrl" />
            </div>
            <div class="upload-cover">
                <Icon type="ios-trash-outline" @click.native="removeFile()"></Icon>
                <Icon type="ios-open-outline" @click.native="showPreviewImage = true"></Icon>
                <!-- <Icon type="md-open" /> -->
            </div>
        </div>
        <div class="audio_box" v-else-if="audioUrl">
            <audio :src="audioUrl" controls></audio>
            <Button type="error" shape="circle" icon="ios-trash-outline" @click="removeFile()"></Button>
            <p>{{audioName||''}}</p>
        </div>
        <div v-else-if="pdfUrl" class="srt_box">
            <div class="srt_box_info">
                <Icon type="md-document" size="45" />
                <Button
                    type="error"
                    shape="circle"
                    icon="ios-trash-outline"
                    @click="removeFile()"
                    style="margin-left: 20px"
                ></Button>
                <br />
                <a :href="pdfUrl" download target="_blank">{{pdfUrl}}</a>
            </div>
        </div>
        <div v-else-if="packageUrl" class="srt_box">
            <div class="srt_box_info">
                <Icon type="ios-folder" size="45" />
                <Button
                    type="error"
                    shape="circle"
                    icon="ios-trash-outline"
                    @click="removeFile()"
                    style="margin-left: 20px"
                ></Button>
                <br />
                <a :href="packageUrl">{{packageUrl}}</a>
            </div>
        </div>
        <div class="upload_box" v-else>
            <Upload
                :before-upload="handleUpload"
                :accept="fatherType | changeFatherAccept"
                ref="upload"
                type="drag"
                :data="uploadData"
                :action="uploadUrl"
            >
                <div style="padding: 30px 0">
                    <Icon
                        v-if="uploading"
                        type="ios-loading"
                        size="18"
                        class="spin-icon-load"
                        style="color: #3399ff;margin-bottom: 10px"
                    ></Icon>
                    <Icon
                        v-else
                        :type="fatherType | changeFatherIcon"
                        size="40"
                        style="color: #3399ff;margin-bottom: 10px"
                    ></Icon>
                    <p v-if="uploading">{{fatherType | changeFatherType}}文件上传中, 请稍后</p>
                    <p v-else>将{{fatherType | changeFatherType}}文件拖拽到此，或直接上传</p>
                </div>
            </Upload>
        </div>
        <Modal v-model="showPreviewImage" fullscreen footer-hide title="图片预览">
            <div class="preview_image_box" :style="`background-image: url(${imageUrl});`" alt=""></div>
        </Modal>
    </div>
</template>
<script>
import { Upload, Progress } from "iview";
import http from "../../libs/http.js";
import { uploadPackage, uploadFile } from "../../libs/upload.js";
import "../../assets/js/aliyun-oss.min.js";
import "../../assets/js/aliyun-upload.min.js";
import { getVideoData } from "@/api/common";
export default {
    data() {
        return {
            returnData: null,
            // uploadType: 1, //1图片 2音频 3视频 4家长下载图 5教师端图片 6上传pdf文件 7压缩包
            uploadUrl: http.uploadUrl(),
            // image
            imageUrl: "",
            // audio
            audioName: "",
            audioUrl: "",
            // video
            videoInfo: {},
            coverUrl: "",
            mp4PlayUrl: "",
            title: "",
            srt: "",
            //pdf
            pdfUrl: "",
            //压缩包
            packageUrl: "",
            // uploadVideo
            videoLoading: false,
            isShowName: null,
            showName: "",
            uploadVideoAuth: {},
            uploadPercent: 0,
            uploadStatus: "",
            // image,audio
            uploading: false,
            cateId: "",
            showPreviewImage:false,
        };
    },
    filters: {
        changeFatherType: function (type) {
            switch (type + "") {
                case "1":
                    return "图片";
                case "2":
                    return "音频";
                case "3":
                    return "视频";
                case "4":
                    return "图片";
                case "5":
                    return "图片";
                case "6":
                    return "pdf";
                case "7":
                    return "资源";
                case "8": // 1M
                    return "图片";
                case "9":
                    return "doc";
                case "10":
                    return "xlxs";
                case "11":
                    return "ppt";
            }
        },
        changeFatherAccept: function (type) {
            switch (type + "") {
                case "1":
                    return "image/*";
                case "2":
                    return "audio/wav,audio/mp3";
                case "3":
                    return "video/*";
                case "4":
                    return "image/*";
                case "5":
                    return "image/*";
                case "6":
                    return ".pdf";
                case "7":
                    return "";
                case "8":
                    return "image/*";
                case "11":
                    return ".ppt,.pptx,.pps,.ppsx"
            }
        },
        changeFatherIcon: function (type) {
            switch (type + "") {
                case "0":
                    return "spin-icon-load";
                case "1":
                    return "md-image";
                case "2":
                    return "ios-musical-notes";
                case "3":
                    return "ios-videocam";
                case "4":
                    return "md-image";
                case "5":
                    return "md-image";
                case "6":
                    return "md-document";
                case "7":
                    return "ios-folder";
                case "8":
                    return "md-image";
                case "11":
                    return "md-document";
            }
        },
    },
    props: ["fatherType", "fatherData", "uploadData"],
    watch: {
        fatherData(data) {
            if (!data) {
                this.removeFile();
                this.audioName = "";
            }
            switch (this.fatherType + "") {
                case "1":
                    this.imageUrl = data;
                    break;
                case "2":
                    this.audioUrl = data;
                    break;
                case "3":
                    this.videoInfo = data;
                    if (data) {
                        if (data.videoId) {
                            this.setVideoDataById(data.videoId)
                        }
                        this.title = data.title || "";
                        this.srt = data.srt || "";
                        this.showName = data.showName || "";
                        this.isShowName = String(data.isShowName) || null;
                        this.uploadStatus = "";
                        this.uploadVideoAuth = {};
                    }
                    break;
                case "4":
                    this.imageUrl = data;
                    break;
                case "5":
                    this.imageUrl = data;
                    break;
                case "6":
                    this.pdfUrl = data;
                    break;
                case "7":
                    this.packageUrl = data;
                    break;
                case "8":
                    this.imageUrl = data;
                    break;
                case "11":
                    this.packageUrl = data;
                    break;
            }
        },
        uploadStatus(status) {
            if (status == "onUploadEnd" && this.uploadVideoAuth.videoId) {
                this.getVideoDataAuto();
            }
        },
        showName() {
            this.videoInfo.showName = this.showName;
            this.returnData = this.videoInfo;
            this.emitReturnData();
        },
        isShowName() {
            this.videoInfo.isShowName = Number(this.isShowName);
            this.returnData = this.videoInfo;
            this.emitReturnData();
        },
    },
    created() {
        switch (this.fatherType + "") {
            case "1":
                this.imageUrl = this.fatherData;
                break;
            case "2":
                this.audioUrl = this.fatherData;
                break;
            case "3":
                this.videoInfo = this.fatherData;
                if (this.fatherData.videoId) {
                    this.setVideoDataById(this.fatherData.videoId)
                }
                this.title = this.fatherData.title || "";
                this.srt = this.fatherData.srt || "";
                this.showName = this.fatherData.showName || "";
                this.isShowName = String(this.fatherData.isShowName) || null;
                break;
            case "4":
                this.imageUrl = this.fatherData;
                break;
            case "5":
                this.imageUrl = this.fatherData;
                break;
            case "6":
                this.pdfUrl = this.fatherData;
                break;
            case "7":
                this.packageUrl = this.fatherData;
                break;
            case "8":
                this.imageUrl = this.fatherData;
                break;
            case "11":
                this.packageUrl = this.fatherData;
                break;
        }
    },
    methods: {
        async setVideoDataById(videoId) {
            const res = await getVideoData(videoId);
            if (!res || !res.mp4PlayUrl) {
                this.$Message.error("获取视频失败, 请刷新重试或重新上传");
                return
            }
            this.coverUrl = res.coverUrl || "";
            this.mp4PlayUrl = res.mp4PlayUrl || "";
        },
        removeSrt() {
            this.srt = "";
            this.videoInfo.srt = this.srt;
            this.returnData = this.videoInfo;
            this.emitReturnData();
        },
        removeVideo() {
            this.id = "";
            this.videoId = "";
            this.title = "";
            this.duration = "";
            this.coverUrl = "";
            this.creationTime = "";
            this.mp4PlayUrl = "";
            this.hdPlayUrl = "";
            this.status = "";
            this.showName = "";
            this.isShowName = "";
            this.videoInfo = {
                id: "",
                videoId: "",
                title: "",
                duration: "",
                coverUrl: "",
                creationTime: "",
                mp4PlayUrl: "",
                hdPlayUrl: "",
                status: "",
                showName: "",
                isShowName: "",
                srt: this.srt,
            };
            // this.videoInfo.isShowName = null;
            // this.srt = "";
            // this.videoInfo.srt = this.srt;
            // this.returnData = this.videoInfo;
            // this.emitReturnData();
        },
        handleUpload(file) {
            if(!file.type){
                this.$Message.error(
                    "文件类型有误, 请检查后重新上传"
                );
                return false;
            }
            switch (this.fatherType + "") {
                case "1":
                    if (file.size > 5 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    break;
                //音频
                case "2":
                    if (file.size > 5120 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    break;
                case "3":
                    if (file.size > 5 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    if (file.name.slice(-3) != "srt") {
                        this.$Message.error("文件格式有误,请上传srt格式的字幕");
                        return false;
                    }
                    break;
                case "4":
                    // 家长下载
                    if (file.size > 5 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    break;
                case "5":
                    // 教师端大图
                    if (file.size > 5 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    break;
                case "8":
                    // 教师端大图
                    if (file.size > 5 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于5M的文件"
                        );
                        return false;
                    }
                    break;
                case "11":
                    // 限制ppt上传（.ppt,.pptx,.pps,.ppsx），大小200M以内，
                    if (!file.name.match(/\.(ppt|pptx|pps|ppsx)$/)) {
                        this.$Message.error("文件格式有误,请上传ppt格式文件");
                        return false;
                    }
                    if (file.size > 200 * 1024 * 1024) {
                        this.$Message.error(
                            file.name + "文件超出限制, 请上传小于200M的文件"
                        );
                        return false;
                    }
                    
                    break;
            }
            this.uploading = true;
            let _this = this;
            if (this.fatherType == "7") {
                // 原方法不再适用
                // uploadPackage(file, function (res) {
                uploadFile(file, function (res) {
                    _this.uploadSuccess(res, file);
                });
            } else if(this.fatherType == "11"){
                uploadFile(file, function (res) {
                    _this.uploadSuccess(res, file);
                }, { contentDisposition: 'inline' });
            } else {
                uploadFile(file, function (res) {
                    _this.uploadSuccess(res, file);
                });
                // let formData = new FormData();
                // formData.append("file", file);
                // let _uploadData = this.uploadData || {};
                // for (let key in _uploadData) {
                //     formData.append(key, _uploadData[key]);
                // }
                // http.form("/file/upload", formData).then(res => {
                //     if (res) {
                //         _this.uploadSuccess(res, file);
                //     }
                // });
            }
            return false;
        },
        // 自动获取视频信息
        getVideoDataAuto() {
            let that = this;
            this.videoLoading = true;
            let interval = setInterval(handleGetVideoData, 3000);
            async function handleGetVideoData() {
                const res = await getVideoData(that.uploadVideoAuth.videoId);
                console.log(res);
                if (res.status == "Normal") {
                    clearInterval(interval);
                    that.videoLoading = false;
                    if (res.mp4PlayUrl) {
                        //&&xx
                        // that.inc = incurl
                        that.coverUrl = res.coverUrl;
                        that.mp4PlayUrl = res.mp4PlayUrl;
                        that.videoInfo = res;
                        that.videoInfo.srt = that.srt;
                        that.videoInfo.showName = that.showName;
                        that.videoInfo.isShowName = Number(that.isShowName);
                        that.returnData = that.videoInfo;
                        that.emitReturnData();
                    } else {
                        that.$Message.error("上传失败, 请刷新页面重新上传");
                    }
                }
            }
        },
        // 图片,音频上传成功
        uploadSuccess(res, file) {
            if (this.fatherType + "" == "2") {
                this.audioName = file.name;
                this.returnData = res.url;
            } else if (this.fatherType + "" == "3") {
                this.srt = res.url;
                this.videoInfo.srt = res.url;
                this.returnData = this.videoInfo;
            } else if (String(this.fatherType) === '11') {
                this.returnData = res;
            } else {
                console.log(123213, res);
                this.returnData = res.url;
            }
            this.emitReturnData();
        },
        // 传递给父组件
        emitReturnData() {
            this.uploading = false;
            this.$emit("returnData", this.returnData);
        },
        // 删除数据
        removeFile() {
            if (this.fatherType + "" == "3") {
                this.showName = "";
                this.isShowName = null;
                this.videoInfo = {};
                this.coverUrl = "";
                this.mp4PlayUrl = "";
                this.title = "";
                this.srt = "";
                this.uploadVideoAuth = {};
                this.uploadStatus = "";
                this.returnData = {};
                this.uploadPercent = 0;
            } else {
                this.returnData = "";
            }
            this.emitReturnData();
        },
        // video-upload
        changeVideo(event) {
            let videoFile = event.target.files[0];
            this.title = videoFile.name.substring(
                0,
                videoFile.name.lastIndexOf(".")
            );
            this.getUploadVideoAuth(videoFile, videoFile.name, this.title);
        },
        // 获取视频上传凭证
        getUploadVideoAuth(file, name, title) {
            let that = this;
            let sendData = {
                fileName: name,
                title: title,
            };
            if (this.uploadData.stepType) {
                sendData.stepType = this.uploadData.stepType;
            }
            if (this.uploadData.partType) {
                sendData.stepType = this.uploadData.partType;
            }
            if (this.uploadData.sectionId) {
                sendData.cateId = 672934692; //Hello迈迪
            } else if (this.uploadData.groupId || this.uploadData.partId) {
                sendData.cateId = 1000075351; //Hello迈迪教师端
            } else {
                sendData.cateId = 436244267; //其他
            }
            http.post("/aliyun/video/upload/create", sendData).then((res) => {
                if (res) {
                    that.uploadVideoAuth = res;
                    that.videoInfo.videoId = res.videoId;
                    let userData;
                    that.uploader.addFile(file, null, null, null, userData);
                    that.uploader.startUpload();
                }
            });
        },
    },
    mounted() {
        let that = this;
        if (this.fatherType == "3") {
            this.uploader = new AliyunUpload.Vod({
                //分片大小默认1M，不能小于100K
                partSize: 1048576,
                //并行上传分片个数，默认5
                parallel: 5,
                //网络原因失败时，重新上传次数，默认为3
                retryCount: 3,
                //网络原因失败时，重新上传间隔时间，默认为2秒
                retryDuration: 2,
                // 开始上传
                onUploadstarted: function (uploadInfo) {
                    that.uploadStatus = "onUploadStarted";
                    //上传方式1, 需要根据uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
                    that.uploader.setUploadAuthAndAddress(
                        uploadInfo,
                        that.uploadVideoAuth.uploadAuth,
                        that.uploadVideoAuth.uploadAddress,
                        that.uploadVideoAuth.videoId
                    );
                    //上传方式2
                    // uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret,secretToken);
                },
                // 文件上传成功
                onUploadSucceed: function () {
                    // uploadInfo
                    that.uploadStatus = "onUploadSucceed";
                },
                // 文件上传失败
                onUploadFailed: function () {
                    // uploadInfo, code, message
                    that.uploadStatus = "onUploadFailed";
                },
                // 文件上传进度，单位：字节
                onUploadProgress: function (
                    uploadInfo,
                    totalSize,
                    loadedPercent
                ) {
                    that.uploadStatus = "onUploadProgress";
                    that.uploadPercent = Math.ceil(loadedPercent * 100);
                },
                // 上传凭证超时
                onUploadTokenExpired: function () {
                    // uploadInfo
                    that.uploadStatus = "onUploadTokenExpired";
                    //上传方式1  实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
                    that.uploader.resumeUploadWithAuth(
                        that.uploadVideoAuth.uploadAuth
                    );
                    // 上传方式2 实现时，从新获取STS临时账号用于恢复上传
                    // uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expireTime);
                },
                //全部文件上传结束
                onUploadEnd: function () {
                    // uploadInfo
                    that.uploadStatus = "onUploadEnd";
                },
            });
        }
    },
    destroyed() {
        if (this.fatherType == "3" && this.uploader) {
            this.uploader.stopUpload();
        }
    },
    components: {
        Progress,
        Upload,
    },
};
</script>
